
interface InitialData {
  // tslint:disable-next-line:no-any
  [key: string]: any;
}

export default class InvestorDeckData {
  id?: number;
  investorDeckDocument: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string
  };
  personId: number;
  personType: string;

  constructor(entity: InitialData) {
    this.id = entity.id || undefined;
    this.investorDeckDocument = typeof entity.investorDeckDocument === 'object' ?
      entity.investorDeckDocument :
      { url: entity.investorDeckDocument };
    this.personId = entity.personId;
    this.personType = entity.personType;
  }
}


// WEBPACK FOOTER //
// ./src/value-objects/InvestorDeckData.tsx